import platform from 'components/Trackers/platform'
import { useTracking } from 'utils/analytics/useTracking'

export const useAddressPreviewTracking = () => {
  const track = useTracking(screenViewed)

  return {
    editTapped: () => track.buttonTapped(editTapped),
    confirmTapped: () => track.buttonTapped(confirmTapped),
  }
}

const sharedProps = {
  platform,
  card_type: 'moc',
  context: 'registration',
  screen: 'registrationSpendAddress',
  screen_name: 'registrationSpendAddress',
}

const screenViewed = {
  object: 'Screen',
  action: 'Viewed',
  object_name: 'registrationSpendAddress',
  ...sharedProps,
}

const confirmTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationSpendAddressConfirm',
  ...sharedProps,
}

const editTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationSpendAddressEdit',
  ...sharedProps,
}
